import { createContext, useState, type ReactNode } from 'react'
import { type CurrencyCode, getDefaultCurrencyForLanguage } from '@/utils/currencyUtils'

interface CurrencyContextType {
  currency: CurrencyCode
  setCurrency: (currency: CurrencyCode) => void
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined)

const STORAGE_KEY = 'currency'

const getInitialCurrency = (): CurrencyCode => {
  if (typeof window === 'undefined') return 'EUR'
  const saved = localStorage.getItem(STORAGE_KEY) as CurrencyCode | null
  if (saved) return saved
  // Default based on browser language
  const browserLang = navigator.language.split('-')[0]
  return getDefaultCurrencyForLanguage(browserLang)
}

interface CurrencyProviderProps {
  children: ReactNode
}

export const CurrencyProvider = ({ children }: CurrencyProviderProps) => {
  const [currency, setCurrencyState] = useState<CurrencyCode>(getInitialCurrency)

  const setCurrency = (newCurrency: CurrencyCode) => {
    setCurrencyState(newCurrency)
    localStorage.setItem(STORAGE_KEY, newCurrency)
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export default CurrencyContext
